import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  header: {
    marginBottom: 24
  },
  formHeader: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    paddingBottom: 18
  }
}))
